import React from 'react'
import TechnologyCube from './TechnologyCube';
import ReactLogo from '../images/technologies_icons/REACT_ico.svg';
import NodeLogo from '../images/technologies_icons/NODE_ico.svg';
import BootstrapLogo from '../images/technologies_icons/BOOTSTRAP_ico.svg';
import HtmlLogo from '../images/technologies_icons/HTML5.svg';
import CSSLogo from '../images/technologies_icons/CSS.svg';
import JSLogo from '../images/technologies_icons/JS.svg';
//line 2
import Sql from '../images/technologies_icons/SQL_ico.svg';
import MongoDb from '../images/technologies_icons/MONGO_ico.svg';
import Heroku from '../images/technologies_icons/HEROKU_ico.svg';
import Java from '../images/technologies_icons/JAVA_ico.svg';
import Kotlin from '../images/technologies_icons/KOTLIN_ico.svg';
import Firebase from '../images/technologies_icons/FIREBASE_ico.svg';
//line 3
import Unity from '../images/technologies_icons/UNITY_ico.svg';
import CSharp from '../images/technologies_icons/Csharp_ico.svg';
import Cinema4D from '../images/technologies_icons/CINEMA_ico.svg';
import Oculus from '../images/technologies_icons/OCULUS_ico.svg';
//line 4
import Illustrator from '../images/technologies_icons/AI_ico.svg';
import Photoshop from '../images/technologies_icons/PS_ico.svg';
import Premiere from '../images/technologies_icons/PREMIERE_ico.svg';
import AdobeXD from '../images/technologies_icons/XD_ico.svg';
import Sketch from '../images/technologies_icons/SKETCH_ico.svg';

export default function TechnologiesList()
{
    return(
        <div className="technologies-section">
            <div className="title-section">Technical Skills</div>
            <div className="subtitle-section">Web and Mobile Development</div>
            <div className="line-techs">
                <TechnologyCube image={ReactLogo} name="React js" nStars={3} />
                <TechnologyCube image={NodeLogo} name="Node js" nStars={3} />
                <TechnologyCube image={BootstrapLogo} name="Bootstrap" nStars={4} />
                <TechnologyCube image={HtmlLogo} name="HTML 5" nStars={4} />
                <TechnologyCube image={CSSLogo} name="CSS" nStars={4} />
                <TechnologyCube image={JSLogo} name="Javascript" nStars={3} />
            </div>
            <div className="line-techs">
                <TechnologyCube image={Sql} name="SQL" nStars={3} />
                <TechnologyCube image={MongoDb} name="MongoDb" nStars={2} />
                <TechnologyCube image={Heroku} name="Heroku" nStars={2} />
                <TechnologyCube image={Java} name="Java" nStars={3} />
                <TechnologyCube image={Kotlin} name="Kotlin" nStars={2} />
                <TechnologyCube image={Firebase} name="Firebase" nStars={3} />
            </div>

            <div className="subtitle-section">Videogames and VR</div>
            <div className="line-techs">
                <TechnologyCube image={Unity} name="Unity2D" nStars={3} />
                <TechnologyCube image={Unity} name="Unity3D" nStars={3} />
                <TechnologyCube image={CSharp} name="C sharp" nStars={3} />
                <TechnologyCube image={Cinema4D} name="Cinema4D" nStars={3} />
                <TechnologyCube image={Oculus} name="Oculus" nStars={2} />
            </div>

            <div className="subtitle-section">Design and UI/UX</div>
            <div className="line-techs">
                <TechnologyCube image={Cinema4D} name="Cinema4D" nStars={3} />
                <TechnologyCube image={Illustrator} name="Illustrator" nStars={3} />
                <TechnologyCube image={Photoshop} name="Photoshop" nStars={3} />
                <TechnologyCube image={Premiere} name="Premiere" nStars={2} />
                <TechnologyCube image={AdobeXD} name="Adobe XD" nStars={2} />
                <TechnologyCube image={Sketch} name="Sketch" nStars={2} />
            </div>
        </div>
    )
}